(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reading-button"] && !Shopify.designMode) return;
  try {
    
// ページ内リンクのスムーズスクロール
document.addEventListener('DOMContentLoaded', function() {
  const buttonLinks = document.querySelectorAll('#vc-{{ section.id }} a[href^="#"]');

  buttonLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reading-floating"] && !Shopify.designMode) return;
  try {
    
// ページ内リンクのスムーズスクロール
document.addEventListener('DOMContentLoaded', function() {
  const floatingLinks = document.querySelectorAll('#vc-{{ section.id }} a[href^="#"]');

  floatingLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierra-concept"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      function initializeSwipers() {
          const swiperSettings = {
              direction: 'horizontal',
              loop: true,
              slidesPerView: 1, // 明示的に指定
              speed: 10000,
              allowTouchMove: false,
              slidesPerView: 'auto',
              spaceBetween: 22,
              autoplay: {
                  delay: 0,
              },
              breakpoints: {
                  900: {
                      direction: 'vertical',
                      slidesPerView: 3,
                      spaceBetween: 20,
                      speed: 6000,
                  }
              }
          };

          new Swiper(".concept-swiper", swiperSettings);
      }

      // 初期化関数を実行
      initializeSwipers();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierra-feature"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 900) return; // 900px以下ではスクリプトを実行しない
    
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    const tabs = document.querySelectorAll('.feature-tab-list .feature-link');
    const allLinks = document.querySelectorAll('a[href^="#"]'); // すべてのページ内アンカーリンク
    const featureArea = document.querySelector('.feature-content-area');

    if (!featureArea) {
        return;
    }

    function updateFeatureAreaHeight() {
        return featureArea.offsetHeight;
    }

    // 各タブに対するスクロール位置の割合を定義
    const scrollPositions = {
        "functions": 0.14,
        "shapes": 0.28,
        "design": 0.42,
        "texture": 0.56,
        "custom": 0.70,
        "strength": 0.84
    };

    allLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault(); // デフォルトのアンカーリンク動作を防ぐ

            const targetId = this.getAttribute('href').replace('#', '');
            const targetElement = document.getElementById(targetId);
            const featureAreaHeight = updateFeatureAreaHeight(); // 最新の高さを取得

            if (!targetElement) {
                return;
            }

            let scrollPos;

            if (targetElement.classList.contains('feature-item')) {
                // feature-content-area内の要素の場合
                const featureAreaTop = featureArea.getBoundingClientRect().top + window.scrollY;
                const scrollOffset = featureAreaHeight * (scrollPositions[targetId] || 0);
                scrollPos = featureAreaTop + scrollOffset;
            } else {
                // 通常のアンカーリンク（例: フッターの「トップに戻る」ボタン）
                scrollPos = targetElement.getBoundingClientRect().top + window.scrollY;
            }

            gsap.to(window, {
                scrollTo: {
                    y: scrollPos,
                    autoKill: true
                },
                ease: "power2.inOut",
                duration: 1.2
            });
        });
    });

    // リサイズ時の処理
    function handleResize() {
        if (window.innerWidth <= 900) {
            window.removeEventListener('resize', updateFeatureAreaHeight);
            return;
        }
    }
    
    window.addEventListener('resize', handleResize);
});


        document.addEventListener('DOMContentLoaded', function() {
            function setFeatureHeaderSize() {
                const featuresHead = document.querySelector(".features .heading-top");
                if (featuresHead) {
                    const headHeight = featuresHead.offsetHeight;
                    document.documentElement.style.setProperty('--features-head-height', `${headHeight}px`);

                    // ScrollTrigger の start 位置を再計算
                    updateScrollTrigger(headHeight);
                }
            }

                    if (window.innerWidth >= 900) {
                        // ScrollTrigger の更新処理
                        function updateScrollTrigger(headHeight) {
                            // px を vh に変換 (window.innerHeight を基準)
                            const headSpace = (headHeight) + 50;

                            // 既存の ScrollTrigger を削除
                            ScrollTrigger.getAll().forEach(trigger => trigger.kill());

                            ScrollTrigger.create({
                                trigger: ".feature-content-area",
                                start: `14%-=${headSpace} top`, // 正しい書式に修正
                                end: `28%-=${headSpace} top`, // 正しい書式に修正
                                // markers: true,
                                onEnter: () => {
                                    document.querySelector("#tab-functions").classList.add("active");
                                    gsap.to("#functions", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to(".feature-lead", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-functions", {
                                        backgroundColor: "#2F2F2F",
                                        color: "#ffffff",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                                onLeaveBack: () => {
                                    document.querySelector("#tab-functions").classList.remove("active");
                                    gsap.to("#functions", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to(".feature-lead", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-functions", {
                                        backgroundColor: "#ECECEC",
                                        color: "#2F2F2F",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                            });

                            ScrollTrigger.create({
                                trigger: ".feature-content-area",
                                start: `28%-=${headSpace} top`, // 正しい書式に修正
                                end: `42%-=${headSpace} top`, // 正しい書式に修正
                                // markers: true,
                                onEnter: () => {
                                    document.querySelector("#tab-functions").classList.remove("active");
                                    document.querySelector("#tab-shapes").classList.add("active");
                                    gsap.to("#shapes", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#functions", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-shapes", {
                                        backgroundColor: "#2F2F2F",
                                        color: "#ffffff",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                                onLeaveBack: () => {
                                    document.querySelector("#tab-functions").classList.add("active");
                                    document.querySelector("#tab-shapes").classList.remove("active");
                                    gsap.to("#shapes", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#functions", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-shapes", {
                                        backgroundColor: "#ECECEC",
                                        color: "#2F2F2F",
                                        ease: "power1",
                                        duration: 0.3,
                                    });

                                },
                            });

                            ScrollTrigger.create({
                                trigger: ".feature-content-area",
                                start: `42%-=${headSpace} top`, // 正しい書式に修正
                                end: `56%-=${headSpace} top`, // 正しい書式に修正
                                // markers: true,
                                onEnter: () => {
                                    document.querySelector("#tab-shapes").classList.remove("active");
                                    document.querySelector("#tab-design").classList.add("active");
                                    gsap.to("#design", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#shapes", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-design", {
                                        backgroundColor: "#2F2F2F",
                                        color: "#ffffff",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                                onLeaveBack: () => {
                                    document.querySelector("#tab-shapes").classList.add("active");
                                    document.querySelector("#tab-design").classList.remove("active");
                                    gsap.to("#design", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#shapes", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-design", {
                                        backgroundColor: "#ECECEC",
                                        color: "#2F2F2F",
                                        ease: "power1",
                                        duration: 0.3,
                                    });

                                },
                            });

                            ScrollTrigger.create({
                                trigger: ".feature-content-area",
                                start: `56%-=${headSpace} top`, // 正しい書式に修正
                                end: `70%-=${headSpace} top`, // 正しい書式に修正
                                // markers: true,
                                onEnter: () => {
                                    document.querySelector("#tab-design").classList.remove("active");
                                    document.querySelector("#tab-texture").classList.add("active");
                                    gsap.to("#texture", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#design", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-texture", {
                                        backgroundColor: "#2F2F2F",
                                        color: "#ffffff",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                                onLeaveBack: () => {
                                    document.querySelector("#tab-design").classList.add("active");
                                    document.querySelector("#tab-texture").classList.remove("active");
                                    gsap.to("#texture", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#design", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-texture", {
                                        backgroundColor: "#ECECEC",
                                        color: "#2F2F2F",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                            });

                            ScrollTrigger.create({
                                trigger: ".feature-content-area",
                                start: `70%-=${headSpace} top`, // 正しい書式に修正
                                end: `84%-=${headSpace} top`, // 正しい書式に修正
                                // markers: true,
                                onEnter: () => {
                                    document.querySelector("#tab-texture").classList.remove("active");
                                    document.querySelector("#tab-custom").classList.add("active");
                                    gsap.to("#custom", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#texture", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-custom", {
                                        backgroundColor: "#2F2F2F",
                                        color: "#ffffff",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                                onLeaveBack: () => {
                                    document.querySelector("#tab-texture").classList.add("active");
                                    document.querySelector("#tab-custom").classList.remove("active");
                                    gsap.to("#custom", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#texture", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-custom", {
                                        backgroundColor: "#ECECEC",
                                        color: "#2F2F2F",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                            });

                            ScrollTrigger.create({
                                trigger: ".feature-content-area",
                                start: `84%-=${headSpace} top`, // 正しい書式に修正
                                end: `105%-=${headSpace} top`, // 正しい書式に修正
                                // markers: true,
                                onEnter: () => {
                                    document.querySelector("#tab-custom").classList.remove("active");
                                    document.querySelector("#tab-strength").classList.add("active");
                                    gsap.to("#strength", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#custom", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-strength", {
                                        backgroundColor: "#2F2F2F",
                                        color: "#ffffff",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                                onLeaveBack: () => {
                                    document.querySelector("#tab-custom").classList.add("active");
                                    document.querySelector("#tab-strength").classList.remove("active");
                                    gsap.to("#strength", {
                                        opacity: 0,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#custom", {
                                        opacity: 1,
                                        ease: "power1",
                                        duration: 0.7,
                                    });
                                    gsap.to("#tab-strength", {
                                        backgroundColor: "#ECECEC",
                                        color: "#2F2F2F",
                                        ease: "power1",
                                        duration: 0.3,
                                    });
                                },
                            });



                            // ScrollTrigger をリフレッシュ
                            ScrollTrigger.refresh();
                        }

                        // ウィンドウのリサイズ時にヘッダーのサイズを更新
                        window.addEventListener("resize", setFeatureHeaderSize);

                        // 初期ロード時にもヘッダーのサイズを設定
                        setFeatureHeaderSize();

                    }
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierra-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      gsap.registerPlugin(ScrollTrigger);

      const mm = gsap.matchMedia();

      // PC用の設定（そのまま）
      mm.add("(min-width: 900px)", () => {
          gsap.utils.toArray('.parallax-img').forEach(wrap => {
              const y = wrap.getAttribute('data-y') || -100;

              gsap.to(wrap, {
                  y: y,
                  scrollTrigger: {
                      trigger: wrap,
                      start: 'top bottom',
                      end: 'bottom top',
                      scrub: 0.3,
                      // markers: true,
                  }
              });
          });
      });

      // スマホ用の設定（個別指定可能）
      mm.add("(max-width: 899px)", () => {
          gsap.utils.toArray('.parallax-img').forEach(wrap => {
              const defaultY = wrap.getAttribute('data-y') || -100;
              const mobileY = wrap.getAttribute('data-mobile-y') || (defaultY * 0.5); // 個別指定がなければ 50%に縮小

              gsap.to(wrap, {
                  y: mobileY,
                  scrollTrigger: {
                      trigger: wrap,
                      start: 'top bottom',
                      end: 'bottom top',
                      scrub: 0.3,
                      // markers: true,
                  }
              });
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierra-header"] && !Shopify.designMode) return;
  try {
    
  let device = window.innerWidth > 900 ? 1 : 0;

  function debounce(func, delay) {
      let timer;
      return function(...args) {
          clearTimeout(timer);
          timer = setTimeout(() => func.apply(this, args), delay);
      };
  }

  function handleResize() {
      if ((window.innerWidth <= 900 && device === 1) || (window.innerWidth > 900 && device === 0)) {
          location.reload();
      }
  }

  window.addEventListener('resize', debounce(handleResize, 100)); // 200msの遅延を指定

  // movement
  if (!(window.innerWidth <= 900)) {
      const elements = [
          { selector: '.fi', className: 'fadeIn' },
          { selector: '.fu', className: 'fadeUp' },
          { selector: '.fd', className: 'fadeDown' },
          { selector: '.flr', className: 'fadel-r' },
          { selector: '.frl', className: 'fader-l' }
      ];

      elements.forEach(({ selector, className }) => {
          const objects = document.querySelectorAll(selector);

          objects.forEach(object => {
              // 指定クラスがある場合のみ処理を実行
              if (object.classList.contains(selector.slice(1))) {
                  object.style.opacity = '0';

                  // コールバック関数を共通化
                  const callback = (entries, observer) => {
                      entries.forEach(entry => {
                          if (entry.isIntersecting) {
                              entry.target.classList.add(className);
                              observer.unobserve(entry.target);
                          }
                      });
                  };

                  // IntersectionObserverのオプションとインスタンス生成
                  const options = {
                      root: null,
                      rootMargin: "0px",
                      threshold: 0
                  };


                  // IntersectionObserverのインスタンス化
                  const observer = new IntersectionObserver(callback, options);

                  // 各オブジェクトを監視
                  observer.observe(object);
              }
          });
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierra-header2"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
